import {GET, POST, PATCH, POST_FILE} from './http';

export const Printers = token => GET('bom-printing/printers', token);
export const Assignments = token => GET('bom-printing/assignments', token);
export const History = (token, limit = 50) => GET(`bom-printing/history?limit=${encodeURIComponent(limit)}`, token);
export const Print = (token, orderId, idempotencyKey) => POST(
    'bom-printing/print',
    {orderId, idempotencyKey},
    token
);
export const Upload = (token, form) => POST_FILE('bom-printing/templates', form, token);
export const AdminPrinters = token => GET('bom-printing/admin/printers', token);
export const CreatePrinter = (token, data) => POST('bom-printing/admin/printers', data, token);
export const UpdatePrinter = (token, id, data) => PATCH(`bom-printing/admin/printers/${id}`, data, token);
export const TestPrinter = (token, id) => POST(`bom-printing/admin/printers/${id}/test`, {}, token);
